export default __webpack_public_path__ + "static/media/icon_digitalAI_active.e9affc51.svg";